<div class="chat-roll-container">
    <div *ngFor="let msg of chatMsgs; let msgIdx = index">
        <div class="consultantMsg" *ngIf="isConsultant(msg.participant.type)">
                <div class="chatroll_consultant">
                    <!-- <div id="consultantPhoto" [ngStyle]="{'background-image': 'url(' + msg.participant.photoURL + ')'}"></div> -->
                    <div class="chat-roll-consultantDetails">
                        <img class="consultantPhoto" src="{{imageRootFolder}}consultant.png">
                        <div class="chat-roll-consultantName">{{"discoveryProcess.consultantName" | translate}}</div>
                    </div>                
                    <div id="spacingPhotoAndText"></div>
                    <div id="questionText" [innerHTML]="msg.text"></div>
                </div>
        </div>
        <div class="userMsg" *ngIf="!isConsultant(msg.participant.type)">
            <div id="user">
                    <span class="chat-roll_responseAndButtonContainer">
                        <div id="questionTextUser" [innerHTML]="msg.text"></div>
                        <button mat-button *ngIf="chatMsgs.length > 0 && msgIdx == (chatMsgs.length -1)" class="chat-roll_selectDifferntAnswer" (click)="selectDifferentAnswer()">{{"discoveryProcess.selectDifferentAnswer" | translate}}</button>
                    </span>
                    <div class="spacingPhotoAndText"></div>
                    <div class="responseMemeberIcon">
                        <span class="initials">{{chatParticipantInitials}}</span>
                    </div>
                </div>
            <!-- <div id="userTimestamp"><span class="timeSpacer"></span>{{msg.timestamp}}</div> -->
        </div>
    </div>

</div>

